<div [ngClass]="cdkConfig.layout.navbar.primaryBackground">
    <cdk-navigation layout="horizontal"></cdk-navigation>
</div>